module.exports = "<svg id=\"search\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 0 A12 12 0 0 0 0 12 A12 12 0 0 0 12 24 A12 12 0 0 0 18.5 22.25 L28 32 L32 28 L22.25 18.5 A12 12 0 0 0 24 12 A12 12 0 0 0 12 0 M12 4 A8 8 0 0 1 12 20 A8 8 0 0 1 12 4\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./src/assets/icons/ui/search.svg
// module id = 85
// module chunks = 0